<template>
  <div class="kChart">
    <ul class="headerList">
      <div :class="{ leadList: stepList == 1 && stepType <= newGuideIdx }">
        <li>
          <label class="tit">标的:</label>
          <p>
            <span class="titsymbol">{{ getKsubject.symbol }}-{{ getKsubject.name }}</span>
            <el-button size="small" @click="symbolfun(null, 'symbol')">更换标的</el-button>
          </p>
        </li>
        <div
          class="digBox"
          v-if="stepList == 1 && stepType <= newGuideIdx"
          style="right: -106px; top: 22px">
          <img src="../assets/image/lead1.png" />
          <h3>请选择标的名称</h3>
        </div>
      </div>
      <!-- <li>
        <label class="tit">标的:</label>
        <p>
          <span
            class="titCen"
            :class="{'active':item.symbol==getKdataTo.symbol&&item.exchange==getKdataTo.exchange}"
            v-for="(item,idx) in headerData.codeDataTOList"
            @click="symbolfun(item,'symbol')"
            :key="idx"
          >{{item.name}}{{item.symbol}}</span>
        </p>
      </li>-->
      <li>
        <label class="tit">时间:</label>
        <p>
          <span class="titCenData"
            >{{ headerData.startDate }}&nbsp;&nbsp;至&nbsp;&nbsp;{{
              headerData.endDate
            }}</span
          >
          <span
            style="font-size: 12px; padding-left: 10px"
            v-if="getKdataTo.frequency == 'min.1'"
            >(非交易日则无数据)</span
          >
        </p>
      </li>
      <div :class="{ leadList: stepList == 2 && stepType <= newGuideIdx }">
        <li>
          <label class="tit">频率:</label>
          <p>
            <span v-for="(item, idx) in headerData.freqList" :key="idx">
              <template>
                <span
                  class="titCen"
                  :class="{ active: item.code == getKdataTo.frequency }"
                  v-on:click.stop="symbolfun(item, 'frequency')"
                  >{{ item.name }}</span>
                <el-date-picker
                  v-model="startDateVal"
                  type="date"
                  placeholder="选择日期"
                  size="small"
                  :clearable="false"
                  value-format="yyyy-MM-dd 18:00:00"
                  @change="pickerTime"
                  v-if="item.code == 'min.1' && getKdataTo.frequency == 'min.1'"
                  style="width: 150px; margin: 0 10px"
                  :picker-options="picker"
                ></el-date-picker>
                <el-select
                  v-model="itemSel"
                  style="width: 150px; margin: 0 10px"
                  v-if="item.code == 'min.5' && getKdataTo.frequency == 'min.5'"
                  placeholder="请选择"
                  @change="pickerSele">
                  <el-option
                    v-for="items in itemOptions"
                    size="small"
                    :key="items.value"
                    :label="items.label"
                    :value="items.value"
                  ></el-option>
                </el-select>
              </template>
            </span>
          </p>
        </li>
        <div class="digBox" v-if="stepList == 2 && stepType <= newGuideIdx">
          <img src="../assets/image/lead1.png" />
          <h3 style="margin-left: -29px;">请选择频率</h3>
        </div>
      </div>
      <div :class="{ leadList: stepList == 3 && stepType <= newGuideIdx }">
        <li>
          <label class="tit">复权:</label>
          <p>
            <el-button
              class="fuquan"
              type="text"
              :class="{
                active: item.code == getKdataTo.reinstatement,
                titCen: getKsubject.type != 'future',
              }"
              v-for="(item, idx) in headerData.fqList"
              @click="symbolfun(item, 'reinstatement')"
              :key="idx"
              :disabled="getKsubject.type == 'future'"
              >{{ item.name }}</el-button
            >
          </p>
          <el-popover placement="right" width="400" trigger="hover">
            <ul class="promptUl">
              <li style="margin-bottom: 10px">
                不复权：除权，不消除由于除权除息造成的价格走势畸变<br />
              </li>
              <li style="margin-bottom: 10px">
                前复权：以目前股价为基准，保持现有价位不变，缩减以前价格，把除权前的K线向下平移，使图形吻合，保持股价走势的连续性，
                计算公式：复权后价格=(复权前价格-现金红利)/(1+流通股份变动比例)<br />
              </li>
              <li>
                后复权：指在K线图上以除权前的价格为基准来测算除权后股票的市场成本价，计算公式：复权后价格=复权前价格×(1+流通股份变动比例)+现金红利
              </li>
            </ul>
            <i class="el-icon-question prompt" slot="reference"></i>
          </el-popover>
        </li>
        <div class="digBox" v-if="stepList == 3 && stepType <= newGuideIdx">
          <img src="../assets/image/lead1.png" />
          <h3 style="margin-left: -30px;">请选择复权</h3>
        </div>
      </div>
    </ul>
    <!-- k线图 -->
    <div
      class="box-card"
      v-loading="loading"
      style="position: relative"
      v-if="initType"
    >
      <candlestick
        :homeTitle="getKsubject.name"
        :getData="getData"
        :startTime="startTime"
        @onZoomInit="echartInit"
        :endTime="endTime"
        ref="kdata"
      ></candlestick>
      <!-- <div class="cardBox" v-if="stepList == 3 && stepType <= newGuideIdx">
        <h3>向下划动滚轮查看更长时间行情数据</h3>
        <p class="cardBox_p">
          <label class="cardBox_lab1">
            <label class="cardBox_lab2"></label>
          </label>
        </p>
      </div> -->
    </div>
    <!-- 标的弹窗 -->
    <subject
      :headerData="headerData"
      ref="subject"
      @onSucceed="onSucceed"
      :symbolVisible="symbolType"
      :getKsubject="getKsubject"
    ></subject>
    <!-- 指引 -->
    <template v-if="stepType <= newGuideIdx">
      <div class="leadBox"></div>
      <!-- <div class="skip" @click="stepType = 'null'">跳过</div> -->
      <div class="nextStep" v-if="getKsubject.symbol">
        <el-button @click="stepList--" v-if="stepList != 1">上一步</el-button>
        <el-button type="primary" v-if="stepList != 3" @click="stepList++">下一步</el-button>
        <el-button type="primary" v-else @click="onload">完成</el-button>
      </div>
    </template>
  </div>
</template>
<script>
import TimeUtil from "@/util/TimeUtil.js";
import subject from "@/components/subjectDialog/subject.vue"; // 标的弹窗
import candlestick from "@/views/factorAnalysis/common/echarts/homeEcharts.vue";
export default {
  components: { candlestick, subject },
  data() {
    let than = this;
    return {
      // 新手指引
      stepList: 1, // 步数
      stepType: 0, // 记录进入次数
      newGuideIdx: this.$store.state.newGuideIdx, // 限制次数
      initType: false,
      picker: {
        disabledDate(time) {
          return (
            time.getTime() < new Date(than.startDate).getTime() ||
            time.getTime() > new Date(than.endDate).getTime()
          );
        },
      },
      startDateVal: "",
      startTime: "0",
      endTime: "30",
      endDate: "", // 结束时间
      startDate: "",
      itemSel: "", // 日期
      itemOptions: [
        {
          label: "一月",
          value: "2016-01-31 18:00:00",
        },
        {
          label: "二月",
          value: "2016-02-29 18:00:00",
        },
        {
          label: "三月",
          value: "2016-03-31 18:00:00",
        },
        {
          label: "四月",
          value: "2016-04-30 18:00:00",
        },
        {
          label: "五月",
          value: "2016-05-31 18:00:00",
        },
        {
          label: "六月",
          value: "2016-06-30 18:00:00",
        },
        {
          label: "七月",
          value: "2016-07-31 18:00:00",
        },
        {
          label: "八月",
          value: "2016-08-31 18:00:00",
        },
        {
          label: "九月",
          value: "2016-09-30 18:00:00",
        },
        {
          label: "十月",
          value: "2016-10-31 18:00:00",
        },
        {
          label: "十一月",
          value: "2016-11-30 18:00:00",
        },
        {
          label: "十二月",
          value: "2016-12-31 18:00:00",
        },
      ],
      // 标的
      symbolType: false,
      getKsubject: {},
      loading: false,
      headerData: {},
      getData: [],
      getKdataTo: {
        endDate: "", // 數據結束時間
        exchange: "", // 市場
        frequency: "day.1", // 频率: m.1, m.5, m.30, m.60, d.1, d.w, d.m day.month
        reinstatement: "na", // 复权,na,fward,bward
        startDate: "", // 數據開始時間
        symbol: "", // 标的
      },
    };
  },

  methods: {
    reset(){
      //  this.stepList= 1; // 步数
      // this.stepType= 0; // 记录进入次数
      // this.newGuideIdx = this.$store.state.newGuideIdx; // 限制次数
      // this.initType = false;
    },
    // 完成
    onload(){
      this.initType= true;
      this.stepType = 'null';
      this. getKData();
    },
    // 日期
    pickerSele(item) {
      // const day1 = new Date(item.slice(0, 8) + "01 18:00:00");
      //   day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
      //   let openDate = TimeUtil.DateTimeToString(day1);
      const day1 = new Date(item.slice(0, 8) + "01");
      this.getKdataTo.startDate =
        TimeUtil.aheadInit(day1).slice(0, 10) + " 18:00:00"; //openDate;//item.slice(0, 8) + "01 18:00:00";
      this.getKdataTo.endDate = item;
      this.getKData();
    },
    // 时间选择
    pickerTime(item) {
      // const day1 = new Date(item);
      // day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
      // let openDate = TimeUtil.DateTimeToString(day1);
      // TimeUtil.aheadInit()
      this.startDateVal = item;
      this.getKdataTo.startDate =
        TimeUtil.aheadInit(item).slice(0, 10) + " 18:00:00";
      this.getKdataTo.endDate = item.slice(0, 10) + " 18:00:00";
      this.getKData();
      // this.getFactor.date = item;
    },
    // 频率
    refName(name) {
      this.$refs[name][0].doShow();
    },
    echartInit(item) {
      this.startTime = item.start.toString();
      this.endTime = item.end.toString();
      this.$nextTick(() => {
        // this.$refs.picEchart[1].echartsInit();
        this.$refs.kdata.echartsInit();
      });
    },
    onSucceed(item, type) {
      this.symbolType = false;
      if (type) {
        this.stepList++
        this.getKsubject = item;
        if (item.type == "future") {
          this.getKdataTo.reinstatement = "na";
        }
        // 初始化
        this.getKdataTo.symbol = item.symbol;
        this.getKdataTo.exchange = item.exchange;
        this.getKData();
      }
    },
    // 切换nav
    symbolfun(item, type) {
      if (type == "symbol") {
        // 标的
        this.symbolType = true;
        this.$refs.subject.selectBtn(this.getKsubject); // 默认显示第一个
        return;
      } else if (type == "frequency") {
        this.getKdataTo.startDate = this.startDate;
        this.getKdataTo.endDate = this.endDate;
        if (item.code == "min.1") {
          this.startTime = "0";
          this.endTime = "50";
          this.getKdataTo.startDate = this.startDateVal;
          this.getKdataTo.endDate = this.startDateVal.slice(0, 11) + "18:00:00";
          // const day1 = new Date(this.startDateVal);
          // day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
          // let openDate = TimeUtil.DateTimeToString(day1);
          this.getKdataTo.startDate =
            TimeUtil.aheadInit(this.startDateVal).slice(0, 10) + " 18:00:00"; // openDate.slice(0, 10) + " 18:00:00";
          this.getKdataTo.endDate =
            this.startDateVal.slice(0, 10) + " 18:00:00";
        } else if (item.code == "min.5") {
          this.startTime = "0";
          this.endTime = "30";
          const day1 = new Date(this.itemSel.slice(0, 8) + "01");
          // day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
          // let openDate = TimeUtil.DateTimeToString(day1);
          this.getKdataTo.startDate =
            TimeUtil.aheadInit(day1).slice(0, 10) + " 18:00:00";
          this.getKdataTo.endDate = this.itemSel;
        } else if (item.code == "min.30") {
          this.startTime = "0";
          this.endTime = "10";
        } else if (item.code == "min.60") {
          this.startTime = "0";
          this.endTime = "20";
        } else if (item.code == "day.1") {
          this.startTime = "0";
          this.endTime = "30";
        } else if (item.code == "day.week") {
          this.startTime = "0";
          this.endTime = "100";
        } else if (item.code == "day.month") {
          this.startTime = "0";
          this.endTime = "100";
        }
        // 频率
        this.getKdataTo.frequency = item.code;
      } else if (type == "reinstatement") {
        // 复权
        this.getKdataTo.reinstatement = item.code;
      }
      this.getKData();
    },
    // 初始化参数
    getKLineParam() {
      this.$api.hubei.getKLineParam().then((res) => {
        if (res) {
          const day1 = new Date(res.startDate);
          day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
          let openDate = TimeUtil.DateTimeToString(day1);

          this.headerData = res;
          // this.getKsubject = res.codeDataTOList[0]; // 标的
          this.startDate =
            TimeUtil.aheadInit(res.startDate).slice(0, 10) + " 18:00:00"; //openDate.slice(0, 10) + " 18:00:00"; // 结束时间
          this.endDate = res.endDate.slice(0, 11) + "18:00:00"; // 结束时间
          this.itemSel = res.endDate.slice(0, 11) + "18:00:00";
          this.getKdataTo.startDate =
            TimeUtil.aheadInit(res.startDate).slice(0, 10) + " 18:00:00"; //openDate.slice(0, 10) + " 18:00:00";
          this.getKdataTo.endDate = res.endDate.slice(0, 11) + "18:00:00";
          this.getKdataTo.exchange = res.codeDataTOList[0].exchange;
          this.getKdataTo.symbol = res.codeDataTOList[0].symbol;

          this.itemOptions.forEach((element, idnx) => {
            element.value = res.startDate.slice(0, 4) + element.value.slice(4);
          });
         
          this.getKData();
          this.$nextTick(() => {
            this.$refs.subject.ngOnInit();
          });
        }
      });
    },
    // 获取K线图数据
    getKData() {
      this.loading = true;
      this.$api.hubei.getKData(this.getKdataTo).then((res) => {
        this.loading = false;
        if (!this.startDateVal) {
          this.startDateVal =
            res.kDataTOList[0].tradeTime.slice(0, 11) + "18:00:00";
        }

        this.getData = res.kDataTOList || [];
         if(this.initType){
             this.$nextTick(() => {
              this.$refs.kdata.echartsInit();
            });
          }
       
      });
    },
    // 新手指引
    localGet() {
      if (JSON.parse(localStorage.getItem("webSizeIdx"))) {
        this.stepType = Number(localStorage.getItem("webSizeIdx"));
        const webSizeIdx = Number(localStorage.getItem("webSizeIdx")) + 1;
        localStorage.setItem("webSizeIdx", webSizeIdx);
      } else {
        localStorage.setItem("webSizeIdx", 1);
      }
    },
  },
  created() {
    this.reset();
    this.getKLineParam();
    this.$ILab.StartStep("home")
    // this.localGet();
  },
};
</script>
<style lang="less" scoped>
.kChart .headerList li .active {
  color: #fff !important;
  background: rgba(63, 152, 241, 1);
  border-radius: 4px;
  font-size: 14px;
}
.kChart {
  position: relative;
  .headerList {
    li {
      font-size: 14px;
      color: #666666;
      margin-bottom: 20px;
      font-family: MicrosoftYaHei;
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-box;
      .tit {
        color: #3f98f1;
        display: inline-block;
        width: 50px;
        line-height: 34px;
      }
      > span {
        display: inline-block;
        padding: 0 15px;
        height: 30px;
        line-height: 30px;
      }
      .titCenData {
        display: inline-block;
        padding: 0 15px;
        height: 30px;
        line-height: 30px;
      }
      .titCen {
        display: inline-block;
        padding: 0 15px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        color: #666666;
        margin: 0 5px;
        border: 1px solid #3f98f1;
        border-radius: 4px;
      }
      .fuquan {
        display: inline-block;
        padding: 0 15px;
        height: 30px;
        line-height: 30px;
        color: #666666;
      }
      .titsymbol {
        display: inline-block;
        padding: 0 15px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
      }
      .titCen:hover {
        color: #fff;
        background: rgba(63, 152, 241, 1);
        border-radius: 4px;
        font-size: 14px;
      }
    }
  }
}
// 新手指引
.leadBox {
  margin-left: -16px;
  background: rgba(51, 51, 51, 0.3);
  position: fixed;
  top: 0px;
  // width: calc(100% - 64px);
  width: 100%;
  height: 100%;
  right: 0;
  bottom: 0;
}
.cardBox {
  position: absolute;
  left: 172px;
  z-index: 10;
  bottom: 84px;
  color: #fff;
  font-size: 24px;
}
.leadList {
  position: relative;
  z-index: 9;
  background: #ffffff;
  display: inline-block;
  border-radius: 10px;
  padding: 10px 10px 0 10px;
  //  pointer-events: none;
  .digBox {
    position: absolute;
    right: -98px;
    z-index: 10;
    top: 44px;
    color: #fff;
    font-size: 24px;
    h3 {
      margin-left: -80px;
    }
  }
}
.skip {
  position: absolute;
  right: 12%;
  top: 0;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
}
.nextStep {
    position: absolute;
    font-size: 21px;
    color: #fff;
    text-align: center;
    cursor: pointer;
    left: 500px;
    top: 30%;
}
.cardBox_p {
  width: 37px;
  height: 85px;
  background: #ffffff;
  border-radius: 33px;
  text-align: center;
  margin: 0 auto;
  padding: 10px;
  padding-top: 14px;
  .cardBox_lab1 {
    width: 17px;
    height: 36px;
    border-radius: 9px;
    border: 1px solid #979797;
    display: block;
  }
  .cardBox_lab2 {
    width: 14px;
    height: 14px;
    background: #d8d8d8;
    display: block;
    border-radius: 100%;
  }
}
</style>
